import Confetti from './Confetti';

export default Confetti;